import React from 'react'
import HeroSection from '../../components/HeroSection/HeroSection'
import ContentSection from '../../components/ContentSection/ContentSection'
import MessageSection from '../../components/MessageSection/MessageSection'
import MediaPressSection from '../../components/MediaPressSection/MediaPressSection'
import MessageContainer from '../../components/MessageContainer/MessageContainer'
import ImpactGrid from '../../components/ImpactGrid.jsx/ImpactGrid'
import TextAnimationSection from '../../components/ParallaxScrolling/ParallaxScrolling'
import ScrollTextReveal from '../../components/ui/ScrollTextReveal'
import SEO from '../../components/SEO/SEO'
import { seoConfig } from '../../config/seoConfig'
import RextroBanner from '../../components/RextroBanner/RextroBanner'

const Home = () => {
  //   useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);
  return (
    <>
      <SEO 
        title={seoConfig.home.title}
        description={seoConfig.home.description}
        keywords={seoConfig.home.keywords}
        ogImage={seoConfig.home.ogImage}
        canonical={seoConfig.home.canonical}
      />
      <div className='bg-Color-White'>
      <HeroSection />
      <ContentSection />
      <MessageContainer/>
      <ImpactGrid/>
      {/* Scroll-based Text Reveal Section */}
      <ScrollTextReveal 
        className="bg-gradient-to-b from-Color-White to-gray-50"
        containerHeight="150vh"
        stickyHeight="50%"
        maxWidth="max-w-6xl"
      >
        Building tomorrow's engineers today. For 25 years, the Faculty of Engineering at University of Ruhuna has been a beacon of innovation, excellence, and transformative education.
      </ScrollTextReveal>
      
      {/* <ParallaxScrolling /> */}
      <TextAnimationSection/>
      
      <MessageSection />
      <MediaPressSection />
      <RextroBanner />
      </div>
    </>
  )
}

export default Home
